// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".yOw2{position:relative;display:flex;flex-direction:column}.nzEB{display:flex;align-items:center}._36_y{display:flex;position:relative}._2hwa{margin-left:.8rem}._1swg{position:relative;width:2rem;height:2rem;border:1px solid #373737;border-radius:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;color:transparent;flex-shrink:0;cursor:inherit}._rFm{position:absolute;top:0;left:0;bottom:0;margin:auto;right:0}html[dir=rtl] ._2hwa{margin-left:0;margin-right:.8rem}", ""]);
// Exports
exports.locals = {
	"root": "yOw2",
	"wrapper": "nzEB",
	"checkbox": "_36_y",
	"label": "_2hwa",
	"input": "_1swg",
	"tick": "_rFm"
};
module.exports = exports;
